export const MONTH_INDEX_BY_LABEL = {
	JAN: 0,
	FEV: 1,
	MAR: 2,
	ABR: 3,
	MAI: 4,
	JUN: 5,
	JUL: 6,
	AGO: 7,
	SET: 8,
	OUT: 9,
	NOV: 10,
	DEZ: 11
};

export const formatCycleIdentifier = rawCycle => {
	const rawValue = String(rawCycle || "");

	if (!rawValue) {
		return {
			year: null,
			cycleLabel: "",
			selectValue: "",
			apiValue: ""
		};
	}

	const [year, ...cycleParts] = rawValue.split("-");
	const hasYear = /^\d{4}$/.test(year);
	const cycleLabel = hasYear ? cycleParts.join("-") : rawValue;

	return {
		year: hasYear ? Number(year) : null,
		cycleLabel,
		selectValue: rawValue,
		apiValue: cycleLabel
	};
};

export const buildCycleMonths = ({
	cycle,
	year
}) => {
	const monthLabels = String(cycle || "").split("-");
	let currentYear = Number(year);
	let previousMonthIndex = null;

	return monthLabels.map(label => {
		const normalizedLabel = String(label || "").toUpperCase();
		const monthIndex = MONTH_INDEX_BY_LABEL[normalizedLabel];

		if (previousMonthIndex !== null && monthIndex < previousMonthIndex) {
			currentYear += 1;
		}

		previousMonthIndex = monthIndex;

		return {
			key: normalizedLabel.toLowerCase(),
			label: normalizedLabel,
			startDate: new Date(currentYear, monthIndex, 1).getTime(),
			endDate: new Date(currentYear, monthIndex + 1, 0).getTime()
		};
	});
};